import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useCallback, useContext, useMemo } from 'react';
import { ArticleCtx } from '..';
const ArticleAnchor = (props) => {
    const { children, href } = props;
    const { onLinkClick } = useContext(ArticleCtx);
    const url = useMemo(() => {
        const pattern = /^(http|https):\/\/[^\s]+$/;
        /**
         * find last link
         * @see https://code.byted.org/i18n_fe/n_mono/blob/master/features/article-transcode/component/archor/index.tsx
         */
        return (Children.toArray(children) || [])
            .filter((item) => typeof item === 'string')
            .reduce((pre, cur) => (typeof cur === 'string' && pattern.test(cur.trim()) ? cur : pre), '');
    }, [href, children]);
    const rel = useMemo(() => {
        try {
            const u = new URL(url);
            return u.host.endsWith('.lemon8-app.com') ? void 0 : 'nofollow';
        }
        catch (_) {
            return 'nofollow';
        }
    }, [url]);
    const handleClick = useCallback((e) => {
        onLinkClick(e, {
            link: url,
        });
    }, [url]);
    return (_jsx("a", { target: "_blank", rel: rel, href: url, onClick: handleClick, children: children }));
};
export const ArticleAnchorComponentBuilder = (tag, attr) => {
    if (tag === 'a') {
        return {
            constructor: ArticleAnchor,
            props: {
                href: attr['href'],
            },
        };
    }
    return null;
};
